import Breadcrumbs from '../components/Breadcrumbs';
import Notice from '../components/Notice';
import { Link } from 'react-router-dom';
import { MENU_CATEGORIES, IMG } from '../data/site';

const CAT_IMG = { 'ayam-goreng': IMG.ayamGoreng, 'ayam-bakar': IMG.ayamBakar, pendamping: IMG.sambal, layanan: IMG.rice };
const CAT_ALT = {
  'ayam-goreng': 'Ayam kampung goreng kremes keemasan khas Widuran',
  'ayam-bakar': 'Ayam kampung bakar berbumbu manis gurih',
  pendamping: 'Sambal dan lalapan pendamping ayam goreng',
  layanan: 'Nasi hangat untuk layanan nasi box Widuran',
};

export default function MenuPage() {
  return (
    <>
      <section className="bg-[#F5EFE6] border-b border-[#E2D3BE]">
        <div className="mx-auto max-w-6xl px-5 py-12 sm:py-16">
          <Breadcrumbs items={[{ name: 'Menu', path: '/menu/' }]} />
          <h1 className="font-display text-4xl sm:text-5xl font-bold text-[#2B1B12] tracking-tight mt-6">
            Daftar Menu
          </h1>
          <p className="mt-5 max-w-2xl text-base sm:text-lg leading-relaxed text-[#6E6259]">
            Hidangan khas Widuran — ayam kampung goreng kremes, ayam bakar, sambal, dan pendampingnya.
            Disusun sederhana, seperti papan menu di rumah makan kami.
          </p>
        </div>
      </section>

      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-20 grid gap-14">
        {MENU_CATEGORIES.map((cat) => (
          <section key={cat.id} data-testid={`menu-category-${cat.id}`} aria-labelledby={`h-${cat.id}`}>
            <div className="grid gap-8 lg:grid-cols-12">
              <div className="lg:col-span-4">
                <img
                  src={CAT_IMG[cat.id]}
                  alt={CAT_ALT[cat.id]}
                  width="1000"
                  height="750"
                  loading="lazy"
                  className="rounded-lg w-full aspect-[4/3] object-cover shadow-md"
                />
                <h2 id={`h-${cat.id}`} className="font-display text-2xl sm:text-3xl font-bold text-[#2B1B12] tracking-tight mt-5">
                  {cat.name}
                </h2>
                <p className="mt-2 text-sm leading-relaxed text-[#6E6259]">{cat.note}</p>
              </div>
              <div className="lg:col-span-8">
                <ul className="ticket rounded-t-lg shadow-lg px-7 sm:px-9 pt-7 pb-10">
                  {cat.items.map((m, i) => (
                    <li key={m.name} className={`py-4 flex items-baseline justify-between gap-4 ${i > 0 ? 'ticket-dash' : ''}`}>
                      <div>
                        <h3 className="font-semibold text-[#1A110B]">{m.name}</h3>
                        <p className="text-sm text-[#6E6259] mt-0.5 leading-relaxed">{m.desc}</p>
                      </div>
                      {m.price ? (
                        <span className="font-pricemono font-semibold text-[#8C4A11] whitespace-nowrap">{m.price}</span>
                      ) : (
                        <span className="font-pricemono text-xs text-[#6E6259] whitespace-nowrap">tanya di outlet</span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </section>
        ))}

        <div className="grid gap-6 md:grid-cols-2">
          <div data-testid="menu-price-disclaimer" className="rounded-lg border border-[#E2D3BE] bg-[#F5EFE6] p-6">
            <h3 className="font-pricemono text-xs font-semibold tracking-widest uppercase text-[#8C4A11]">
              Tentang Harga
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-[#6E6259]">
              Harga bertanda ± mengacu pada pemberitaan media per Mei 2025 dan dapat berubah
              sewaktu-waktu. Harga dan ketersediaan menu terkini tersedia langsung di outlet.
            </p>
          </div>
          <Notice variant="box" />
        </div>

        <div className="rounded-lg bg-[#1F140E] grain relative text-[#FDFBF7] p-8 sm:p-12 flex flex-col sm:flex-row sm:items-center gap-6 justify-between">
          <div className="relative z-10">
            <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">
              Pesan Nasi Box untuk Acara Anda
            </h2>
            <p className="mt-3 text-sm sm:text-base text-[#CBBBA6] max-w-lg leading-relaxed">
              Widuran menerima pesanan nasi box untuk acara keluarga dan kantor dalam jumlah besar.
              Hubungi kami untuk detail dan pemesanan.
            </p>
          </div>
          <Link
            to="/kontak/"
            data-testid="menu-cta-nasibox"
            className="relative z-10 shrink-0 inline-flex items-center bg-[#C84B27] text-[#FDFBF7] font-semibold px-7 py-3.5 rounded-md hover:bg-[#a93d1f] transition-colors active:scale-95"
          >
            Hubungi Kami
          </Link>
        </div>
      </div>
    </>
  );
}
